export default __webpack_public_path__ + "static/media/support-orange.87a1f710.svg";